module Meevo.Plugins.ConfirmationManager {
  "use strict";

  /**
  * Main Section of Client 
  */
  export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.AppointmentCategory> {

    /**
  * Base class override which defines what a DEFAULT model looks like.
  */
    createSectionModelInstance(postAdd:(data:any)=>any): void {
      //TODO: Take into account business settings to build model.
      // Possibly hit endpoint i.e /AppointmentCategory/Default to get instance?
        let instance: Model.AppointmentCategory = {
            id: Guid.empty.toString(),
            objectState: Meevo.Model.ObjectStateEnum.Active,
            objectCreationType: Meevo.Model.ObjectCreationTypeEnum.User
        };

      this.model = instance;
    }
  
  }

}